import { NavLink, Outlet } from 'react-router-dom';
import { clsx } from 'clsx';
import styles from './AgencyAgentsPage.module.css';

const TABS = [
  { path: 'skills', label: 'Skills' },
  { path: 'flow', label: 'Flow map' },
  { path: 'overrides', label: 'Overrides' },
] as const;

/**
 * Everything about what an agent *is*, for every practice: the skills on disk,
 * the pipeline generated from them, and the per-location overrides. Three
 * sidebar items became three tabs. What an agent does for one practice —
 * hiring, visibility, schedules, mission, communication — is on that
 * practice's Agents tab, not here.
 */
export function AgencyAgentsPage() {
  return (
    <div className={styles.page}>
      <nav className={styles.tabs} role="tablist" aria-label="Agents">
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            role="tab"
            className={({ isActive }) => clsx(styles.tab, isActive && styles.tabActive)}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
